import { createAction, props } from '@ngrx/store';
import { IFiltroEstadisticaMaquina } from '../models/IFiltroEstadisticaMaquina';
import { IMaquinaInforme } from '../models/IMaquinaInforme';
import { IReporteInforme } from '../models/IReporteInforme';

export const loadCurrentMaquina = createAction(
  'Load Reportes',
  props<{ form: IFiltroEstadisticaMaquina }>()
);

export const loadedCurrentMaquinaError = createAction(
  'Load Reportes Error',
  props<{ error: any }>()
);

export const loadedCurrentMaquinaSuccess = createAction(
  'Load Reportes Success',
  props<{ informeMaquina: IMaquinaInforme }>()
);

export const updateCurrentMaquinaFilter = createAction(
  'Update Filtro de Reportes',
  props<{ form: IFiltroEstadisticaMaquina }>()
);

export const loadedCurrentReportesChartDataSuccess = createAction(
  'Load Current Reportes Chart Data Success',
  props<{ reportes: IReporteInforme }>()
);

export const updateFiltrosSeleccionadosFormEstadisticaBornout = createAction(
  'Update Filtro seleccionados de Reportes',
  props<{ form: any[] }>()
);
export const updateFiltrosSeleccionadosFormEstadisticaLineal = createAction(
  'Update Filtro seleccionados de Reportes de Velocidad',
  props<{ form: any[] }>()
);

export const updateFiltrosSeleccionadosFormEventos = createAction(
  'Update Filtro seleccionados de Reportes de Eventos',
  props<{ form: any[] }>()
);

export const cleanCurrentMaquina = createAction('Clean Reportes');
